// Original: https://github.com/pablojim/highcharts-ng/blob/0.0.13/src/lazyload.js
import './highcharts-ng';

export const highchartsLazyloadModule = angular.module('highcharts-ng-lazyload', ['highcharts-ng']);

highchartsLazyloadModule.provider('highchartsNG', highchartsNGProvider);

/* @ngInject */
function highchartsNGProvider() {
    return {
        $get: /* @ngInject */ function ($q, $window) {
            let loadPromise;

            async function loadHighcharts() {
                const highcharts = await import('highcharts');
                highcharts.wrap(highcharts.Axis.prototype, 'getPlotLinePath', function(proceed) {
                    var path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
                    if (path) {
                        path.flat = false;
                    }
                    return path;
                });

                try {
                    await Promise.all([
                        // Highcharts-more returns installer function that has to be called with highcharts instance
                        import('highcharts/highcharts-more').then(more => more.default(highcharts)),
                        import('highcharts/modules/pattern-fill').then(patternFill => patternFill.default(highcharts)),
                        import('@/angular/libs/vrm-highcharts-sync'),
                        import('@/angular/libs/vrm-highcharts-no-data'),
                        import('@/angular/libs/vrm-highcharts-rounded-corners'),
                        import('@/angular/libs/vrm-highcharts-fractional-containers'),
                    ]);
                } catch (e) {
                    setTimeout(() => $window.location.reload(true), 1000);
                }
                return $q.when(highcharts);
            }

            function getHighcharts() {
                if (!loadPromise) {
                    loadPromise = loadHighcharts();
                }
                return loadPromise;
            }

            return {
                getHighcharts: getHighcharts,
                ready: function ready(callback, thisArg) {
                    getHighcharts().then(function () {
                        callback.call(thisArg);
                    });
                }
            };
        },
    };
}
